import Vue from 'vue'

import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import recurrentPaymentsList from '@/components/services/recurrentPayments/list'
import referrals from '@/components/services/referrals/template'
import settingsUser from '@/components/services/settingsUser/template'
import tariffsGenerator from '@/components/services/tariffs/generator'
import usersBasicForm from '@/components/services/users/form/basic'
import usersRequisites from '@/components/services/users/requisites/template'
import usersTokens from '@/components/services/users/tokens/template'

function renderTabByKey(h, key) {
  switch (key) {
    case 'general': {
      return h(
        usersBasicForm,
        {
          props: {
            value: this.proxy,
            errors: this.errors,
            isAccount: true,
            saveSuccessKey: this.saveSuccessKey
          },
          on: {
            input: event => {
              this.proxy = event
            },
            submit: event => {
              this.$emit('submit', event)
            },
            validation: event => {
              this.$emit('validation', event)
            }
          },
          key
        }
      )
    }

    case Services.settingsUser: {
      return h(
        settingsUser(
          {
            payload: cloneDeep(this.proxy),
            UserId: this.account.id,
            ResellerId: this.account.ResellerId || this.account.Reseller && this.account.Reseller.id
          }
        ),
        {
          class: 'pa-2',
          key
        }
      )
    }

    case Services.tariffs: {
      return h(
        tariffsGenerator,
        {
          props: {
            value: this.proxy.Tariffs,
            readonly: true
          },
          key
        }
      )
    }

    case Services.tokens: {
      return h(
        usersTokens,
        {
          props: {
            OwnerId: this.account.id
          },
          key
        }
      )
    }

    case Services.requisites: {
      return h(
        usersRequisites,
        {
          props: {
            OwnerId: this.account.id,
            User: cloneDeep(this.proxy)
          },
          key
        }
      )
    }

    case Services.recurrentPayments: {
      return h(
        recurrentPaymentsList(),
        {
          key
        }
      )
    }
    case 'referral': {
      return h(
        referrals,
        {
          props: {
            OwnerId: this.proxy.id
          },
          key
        }
      )
    }
  }
}
function renderTab(h, key) {
  return h(
    'div',
    {
      key
    },
    [ renderTabByKey.call(this, h, key) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'fc ff'
    },
    [
      h(
        components['tabs-header'],
        {
          class: 'pt-2 px-2',
          props: {
            value: this.currentTab,
            tabs: this.tabs.map(key => {
              return {
                key,
                title: this.getTranslate(`${Services.users}.tabs.${key}`)
              }
            })
          },
          on: {
            input: event => {
              let query = {}
              if (event === Services.settingsUser) {
                query = this.$route.query
              }
              Vue.router.push({
                name: 'account',
                query: {
                  ...query,
                  currentTab: event
                }
              })
            }
          }
        }
      ),

      h(
        components.tabs,
        {
          props: { value: this.currentTab },
          scopedSlots: {
            body: () => {
              return this.tabs.map(tab => {
                return renderTab.call(this, h, tab)
              })
            }
          }
        }
      )
    ]
  )
}
